// @ts-check

import React, { useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { makeStyles } from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import useFormStyles from '../../../common/FormStyle';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  SET_UNIT_TYPE,
  DELETE_UNIT_TYPE,
  INPUT_CHANGED
} from '../../../../redux/actions/actionTypes'

const useEachUnitTypeStyles = makeStyles({
  unitTypeColor: {
    width: '40px',
    height: '40px',
    backgroundColor: props => props.unitType.color
  },
});

/**
 * In case of a unit deletion the render will be triggered by the change in redux state,
 * but the updatedUnitType will be of the deleted unitType since react is unaware a change happened.
 * We detect the deletion if updatedUnitType does not match the unitType at index.
 */
const updateUnitTypeIfNeeded = (unitType, updatedUnitType, rootState, index) => {
  const utFromStore = rootState.globalFormData.buildingInfo.unit_types[index]
  // this will always be true except on unitType deletion  
  if (utFromStore.id === updatedUnitType.id) {
    // update the redux unitType from the react one (updatedUnitType)
    unitType.name = updatedUnitType.name
    unitType.floor_area = updatedUnitType.floor_area
  }
  return unitType
}


function FlatRow({ unitType, index }) {
  const [updatedUnitType, setUnitType] = useState(unitType);

  const dispatch = useDispatch()
  const unitTypeStyles = useEachUnitTypeStyles({ unitType });
  const formStyles = useFormStyles();

  const rootState = useSelector(state => state)
  updateUnitTypeIfNeeded(unitType, updatedUnitType, rootState, index)

  const [isError, setIsError] = useState(false)

  useEffect(() => {
    // console.log('Change')
    const floor_area = unitType.floor_area
    const plot_length = +rootState.globalFormData.buildingInfo.plot_length
    const plot_width = +rootState.globalFormData.buildingInfo.plot_width
    // console.log('plot_length', plot_length, plot_width)

    const max_plotDimention = (plot_length > plot_width) ? plot_length : plot_width;
    const flat_depth = rootState.globalFormData.buildingInfo.flat_depth

    // console.log('useeffect', floor_area, max_plotDimention, flat_depth, max_plotDimention * flat_depth)

    if (floor_area <= max_plotDimention * flat_depth && rootState.globalFormData.buildingInfo.building_type == "I") {
      setIsError(false)
    } else {
      setIsError(true)
    }


  }, [rootState.globalFormData.buildingInfo.plot_length,
  rootState.globalFormData.buildingInfo.plot_width,
  unitType.floor_area,
  rootState.globalFormData.buildingInfo.flat_depth
  ])


  return (
    <>
      <TableRow
        key={unitType.id}
      >
        <TableCell className={[formStyles.unitsTableCell, formStyles.colorColumn].join(" ")} component="th" scope="row">
          <Box className={unitTypeStyles.unitTypeColor}></Box>
        </TableCell>
        <TableCell className={[formStyles.unitsTableCell, formStyles.unitTypeEditColumn].join(" ")} component="th" scope="row" align="right">
          <TextField
            // error={err}
            // helperText= {err && "Incorrect entry."}
            variant="outlined"
            required
            size="small"
            type="string"
            value={unitType.name}
            onChange={(event) => {
              setUnitType({
                ...unitType,
                name: event.target.value
              })
            }}
            onBlur={(event) => {
              dispatch({
                type: SET_UNIT_TYPE,
                payload: unitType
              })
              dispatch({
                type: INPUT_CHANGED,
                payload: {
                  rootState
                }
              })
            }}
          />
        </TableCell>
        <TableCell className={[formStyles.unitsTableCell, formStyles.floorAreaColumn].join(" ")} component="th" scope="row" align="right">
          <TextField
            error={isError}
            // helperText={!validationState.floor_area.valid && validationState.floor_area.errText}
            variant="outlined"
            required
            size="small"
            type="number"
            value={unitType.floor_area}
            onChange={(event) => {
              setUnitType({
                ...unitType,
                floor_area: parseFloat(event.target.value)
              })
            }}
            onBlur={(event) => {
              dispatch({
                type: SET_UNIT_TYPE,
                payload: unitType
              })
              dispatch({
                type: INPUT_CHANGED,
                payload: {
                  rootState
                }
              })
            }}
          />
        </TableCell>

        <TableCell className={formStyles.unitsTableCell}>
          <IconButton
            size="small"
            style={{ marginTop: "5px" }}
            onClick={(event) => {
              console.log(rootState)
              dispatch({
                type: DELETE_UNIT_TYPE,
                payload: unitType.id
              })
            }}
          >
            <DeleteIcon className={formStyles.deleteIcon} fontSize="small" />
          </IconButton>
        </TableCell>
      </TableRow>

      {isError &&
        <TableRow>
          <td colSpan={4}>
            {

              <Typography style={{ color: 'Red' }}>
                This unit can't fit in your plot.Please reduce its floor area.
              </Typography>
            }
          </td>
        </TableRow>
      }
    </>
  )
}


export default FlatRow